import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VAvatar,_vm._g({staticClass:"ma-2",attrs:{"size":_vm.size,"color":"grey lighten-2"}},on),[_c('img',{class:_vm.borderColor,staticStyle:{"border":"solid 3px white","background-color":"white !important"},attrs:{"src":_vm.avatar,"alt":_vm.username}})])]}}])},[_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.username))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }